import { render, staticRenderFns } from "./OrbitDistributeRewardModal.vue?vue&type=template&id=79f9adde"
import script from "./OrbitDistributeRewardModal.vue?vue&type=script&lang=ts"
export * from "./OrbitDistributeRewardModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitDistributeRewardModal.vue?vue&type=style&index=0&id=79f9adde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports